import { render } from "./alerta_anoletivo.vue?vue&type=template&id=49986859"
import script from "./alerta_anoletivo.vue?vue&type=script&lang=js"
export * from "./alerta_anoletivo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__